module.exports = __webpack_public_path__ + "static/GMDN-Guide-a2ce72da7e9b633e4d3f065a5ff81a3e.pdf";